/**
 * 海报截图页面 mixin
 *
 * 用于 main / moreHonor / historyResult / teamRecordList / home / honorRoll 等页面，
 * 配合 posterCapture.js 与 battalionPoster 组件使用。
 *
 * 页面需具备：
 * - teamHonorPoster / starMemberPoster / battleReportPoster（含 isCapturing 字段）
 * - 海报组件 @poster-ready 绑定对应 captureXxxPoster
 * - lookXxxPoster 中调用 beginPosterCapture(posterState)
 */
import { capturePosterElement, cancelPosterCapture } from '@/util/posterCapture';

export default {
  methods: {
    /**
     * poster-ready 回调中执行截图
     * @param {HTMLElement|string} target 海报根节点，或容器选择器
     * @param {Object} posterState 海报状态对象
     */
    async runPosterCapture(target, posterState) {
      // 仅 beginPosterCapture 开启后允许截图，避免误触发
      if (!posterState || !posterState.isCapturing) {
        return;
      }
      await this.$nextTick();
      const dom = typeof target === 'string' ? document.querySelector(target) : target;
      await capturePosterElement(dom, posterState);
    },
    // poster-ready 会传入 this.$el，选择器仅作兜底
    captureTeamHonorPoster(posterEl) {
      this.runPosterCapture(posterEl || '#teamHonorPosterContainer', this.teamHonorPoster);
    },
    captureStarMemberPoster(posterEl) {
      this.runPosterCapture(posterEl || '#starMemberPosterContainer', this.starMemberPoster);
    },
    captureBattleReportPoster(posterEl) {
      this.runPosterCapture(posterEl || '#battleReportPosterContainer', this.battleReportPoster);
    },
    captureRankPoster(posterEl) {
      this.runPosterCapture(posterEl || '#rankPosterContainer', this.rankPoster);
    },
    cancelPosterCaptureState(posterState) {
      cancelPosterCapture(posterState);
    },
  },
};
